import * as React from 'react'
import { Link } from 'DVWebNodeUI'
import * as styles from './SeeMore.module.scss'
import * as cn from 'classnames'
import checkUrlType from '../../../../utils/url-type-checker'
import { StorefrontLink } from 'DVWebNodeUtils'

interface SeeMoreProps extends StorefrontLink {
  description?: string
}

const SeeMore = (props: SeeMoreProps) => Boolean(props.url && props.label) && (
  <Link
    className={cn(styles.SeeMore, 'tst-see-more')}
    href={checkUrlType(props.url, 'SeeMore')}
    title={props.description}
  >
    {props.label}
  </Link>
)

export default SeeMore
